import { useState, useEffect } from "react"

/**
 * Custom hook for debouncing input with internal state management
 * @param {any} initialValue - Initial value
 * @param {number} delay - Delay in milliseconds
 * @returns {[any, function, any]} [inputValue, setInputValue, debouncedValue]
 */
const useDebounce = (initialValue = "", delay = 500) => {
  const [inputValue, setInputValue] = useState(initialValue)
  const [debouncedValue, setDebouncedValue] = useState(initialValue)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(inputValue)
    }, delay)

    return () => clearTimeout(timer)
  }, [inputValue, delay])

  return [inputValue, setInputValue, debouncedValue]
}

export default useDebounce
